<template>
  <div class="toast-container position-fixed bottom-0 end-0 p-3" style="z-index: 1055">
<!--    <TransitionGroup
      :name="props.animationName"
      tag="div"
      class="toast-wrapper"
    >
      <div
        v-for="toast in toasts"
        :key="toast.id"
        class="toast show"
        :class="getToastClass(toast.type)"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >
        <div class="toast-header">
          <i :class="getIconClass(toast.type)" class="me-2"></i>
          <strong class="me-auto">{{ toast.title }}</strong>
          <small>{{ formatTime(toast.timestamp) }}</small>
          <button
            type="button"
            class="btn-close"
            @click="removeToast(toast.id)"
            aria-label="Close"
          ></button>
        </div>
        <div class="toast-body">
          {{ toast.message }}
        </div>
      </div>
    </TransitionGroup>-->
    <TransitionGroup
        :name="props.animationName"
        tag="div"
        class="toast-wrapper"
    >
      <div
          v-for="toast in toasts"
          :key="toast.id"
          class="alert show"
          :class="getToastClass(toast.type)"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
      >
        <i :class="getIconClass(toast.type)" class="me-2"></i>
        {{ toast.message }}
      </div>
    </TransitionGroup>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import useToast from '@/composables/useToast'

const props = defineProps({
  animationName: {
    type: String,
    default: 'toast'
  }
})

// Použijeme globální toast stav z composable
const { toasts } = useToast()

const getToastClass = (type) => {
  const classes = {
    success: 'alert-success',
    error: 'alert-danger',
    warning: 'alert-warning',
    info: 'alert-info'
  }
  return classes[type] || 'border-secondary'
}

const getIconClass = (type) => {
  const icons = {
    success: 'bi bi-check-circle-fill text-success',
    error: 'bi bi-exclamation-triangle-fill text-danger',
    warning: 'bi bi-exclamation-triangle-fill text-warning',
    info: 'bi bi-info-circle-fill text-info'
  }
  return icons[type] || 'bi bi-bell-fill text-secondary'
}

// const formatTime = (timestamp) => {
//   const now = new Date()
//   const diff = Math.floor((now - timestamp) / 1000)
//
//   if (diff < 60) return 'právě teď'
//   if (diff < 3600) return `před ${Math.floor(diff / 60)} min`
//   return timestamp.toLocaleTimeString('cs-CZ', {
//     hour: '2-digit',
//     minute: '2-digit'
//   })
// }
</script>

<style scoped>
.toast {
  min-width: 300px;
  margin-bottom: 0.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.toast.show {
  opacity: 1;
}

.toast-container {
  z-index: 1055;
}

.toast-wrapper {
  display: flex;
  flex-direction: column;
}

/* Animace pro vjezd zprava */
.toast-enter-active {
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.toast-leave-active {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(100%);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(100%);
  margin-bottom: 0;
  height: 0;
  padding-top: 0;
  padding-bottom: 0;
  overflow: hidden;
}

/* Animace pro přeuspořádání ostatních toastů */
.toast-move {
  transition: transform 0.3s ease;
}

/* Alternativní animace - fade s scale */
.toast-alt-enter-active {
  transition: all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.toast-alt-leave-active {
  transition: all 0.3s ease-in;
}

.toast-alt-enter-from {
  opacity: 0;
  transform: translateX(50px) scale(0.8);
}

.toast-alt-leave-to {
  opacity: 0;
  transform: translateX(50px) scale(0.8);
}

/* Bounce animace */
.toast-bounce-enter-active {
  animation: bounce-in 0.5s;
}

.toast-bounce-leave-active {
  animation: bounce-out 0.3s;
}

@keyframes bounce-in {
  0% {
    transform: translateX(100%) scale(0.3);
    opacity: 0;
  }
  50% {
    transform: translateX(-10px) scale(1.05);
  }
  70% {
    transform: translateX(5px) scale(0.98);
  }
  100% {
    transform: translateX(0) scale(1);
    opacity: 1;
  }
}

@keyframes bounce-out {
  0% {
    transform: translateX(0) scale(1);
    opacity: 1;
  }
  100% {
    transform: translateX(100%) scale(0.3);
    opacity: 0;
  }
}

/* Slide animace shora */
.toast-slide-top-enter-active {
  transition: all 0.4s ease;
}

.toast-slide-top-leave-active {
  transition: all 0.3s ease;
}

.toast-slide-top-enter-from {
  opacity: 0;
  transform: translateY(-100%);
}

.toast-slide-top-leave-to {
  opacity: 0;
  transform: translateY(-50px);
}

/* Pokročilá animace s rotací */
.toast-rotate-enter-active {
  transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.toast-rotate-leave-active {
  transition: all 0.3s ease;
}

.toast-rotate-enter-from {
  opacity: 0;
  transform: translateX(100%) rotate(180deg) scale(0.5);
}

.toast-rotate-leave-to {
  opacity: 0;
  transform: translateX(100%) rotate(-90deg) scale(0.8);
}
</style>